module.exports = __webpack_public_path__ + "static/media/icon-file-txt.691819f9.svg";